import { RELEASE_TYPE } from '../../constants/myBlockMonth';
import { convertToDateTime } from '../../helpers/dateHelpers';
import { formatNumToTime } from '../../helpers/timeHelpers';

export const getReleaseMeasurements = (event, type, index) => {
    const releaseStartTime = convertToDateTime(event.release[index].start_date, formatNumToTime(event.release[index].checkIn.value));
    const releaseEndTime = convertToDateTime(event.release[index].end_date, formatNumToTime(event.release[index].checkOut.value));
    const releaseDuration = releaseEndTime - releaseStartTime; 
    let eventStartTime = convertToDateTime(event.start_date, formatNumToTime(event.checkIn.value));
    let eventEndTime = convertToDateTime(event.end_date, formatNumToTime(event.checkOut.value));
    eventStartTime = event.hasStartRelease ? convertToDateTime(event.release[0].start_date, formatNumToTime(event.release[0].checkIn.value)) : eventStartTime;
    eventStartTime = event.carryIn ? convertToDateTime(event.start_date, '00:00') : eventStartTime;
    eventEndTime = event.hasEndRelease ? convertToDateTime(event.release[event.release.length-1].end_date, formatNumToTime(event.release[event.release.length-1].checkOut.value)) : eventEndTime;
    
    if(type === RELEASE_TYPE.START_WIDTH || type === RELEASE_TYPE.START_MARGIN_LEFT) {
      const eventDuration = eventEndTime - eventStartTime; 
      const releaseDuration = releaseEndTime - eventStartTime; 
      return (releaseDuration/eventDuration) * 100; 
    }
    else if(type === RELEASE_TYPE.END_WIDTH || type === RELEASE_TYPE.END_MARGIN_LEFT) {
        const duration = type === RELEASE_TYPE.END_WIDTH ? releaseDuration : releaseStartTime - eventStartTime;
        const eventDuration = releaseEndTime - eventStartTime; 
        return (duration/eventDuration) * 100; 
    }
    else if(type === RELEASE_TYPE.MIDDLE_WIDTH || type === RELEASE_TYPE.MIDDLE_MARGIN_LEFT) {
        const duration = type === RELEASE_TYPE.MIDDLE_WIDTH ? releaseDuration : releaseStartTime - eventStartTime
        const eventDuration = eventEndTime - eventStartTime;
        return (duration/eventDuration) * 100; 
    }
    return 0;
}